import React, { useState, useEffect } from 'react';

export const VideoByteArray = ( videoPath ) => {
  const [videoSrc, setVideoSrc] = useState('');

  useEffect(() => {
    const loadVideo = async () => {
      try {
        const response = await fetch(videoPath);
        const arrayBuffer = await response.arrayBuffer();
        const byteArray = new Uint8Array(arrayBuffer);
        const blob = new Blob([byteArray], { type: 'video/mp4' });
        const videoURL = URL.createObjectURL(blob);
        setVideoSrc(videoURL);
      } catch (error) {
        console.error('Error loading video:', error);
      }
    };

    loadVideo();
  }, [videoPath]);
  return videoSrc;
};

//export default VideoByteArray;
